
	<form>

		<mat-form-field appearance="outline" class="date-search">
			<mat-date-range-input [formGroup]="dateRangeControl" [rangePicker]="picker">
				<input matStartDate formControlName="start" placeholder="Start date">
				<input matEndDate formControlName="end" placeholder="End date">
			</mat-date-range-input>
			<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
			<mat-date-range-picker #picker></mat-date-range-picker>
		</mat-form-field>

	</form>

<table mat-table [dataSource]="metricsDataSource">

	<ng-container matColumnDef="key">
		<th mat-header-cell *matHeaderCellDef>Metric</th>
		<td mat-cell *matCellDef="let row" class="table-key">
			<div class="mrn sub">{{ row.key}}</div>
		</td>
	</ng-container>

	<ng-container matColumnDef="value">
		<th mat-header-cell *matHeaderCellDef>Value</th>
		<td mat-cell *matCellDef="let row">
			<div class="mrn sub">{{ row.value}}</div>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns;" >

</table>
